export const MenuItems = [
  {
    title : "Home",
    url : "/",
    cName : "nav-links",
    icon : "fa-solid fa-house"
  },
  {
    title : "About",
    url : "/About",
    cName : "nav-links",
    icon : "fa-solid fa-circle-info"
  },
  {
    title : "Industrial Production",
    url : "/Service1",
    cName : "nav-links",
    icon : "fa-solid fa-briefcase"
  },
  {
    title : "Domestic Production",
    url : "/Service2",
    cName : "nav-links",
    icon : "fa-solid fa-briefcase"
  },
  {
    title : "Blogs and Videos",
    url : "/Blog",
    cName : "nav-links",
    icon : "fa-solid fa-briefcase"
  },
  {
    title : "Contact",
    url : "/Contact",
    cName : "nav-links",
    icon : "fa-solid fa-address-book"
  },
  {
    title : "Sign Up",
    url : "/signup",
    cName : "nav-links-mobile"
  }
];
